import { useTranslation } from 'react-i18next';

interface ProviderSelectorProps {
  value: 'band' | 'venue';
  onChange: (v: 'band' | 'venue') => void;
  /** Freeze the selector (lot A2-CAP). Defaults to false. */
  disabled?: boolean;
}

/**
 * Compact "Provided by" selector used under sound/IEM config fields: the band
 * brings the gear (Band) or the venue must provide it (Venue). The rider PDF
 * reflects the choice per transport mode (e.g. bring in-ears on tour bus,
 * but ask for them when flying). (2026-08-08)
 *
 * P3c: it is a two-option pill radio — it now uses the shared `.rc-pill`
 * (`.on` = selected) instead of the legacy indigo/white inline colours.
 * Presentation only.
 */
export default function ProviderSelector({ value, onChange, disabled = false }: ProviderSelectorProps) {
  const { t } = useTranslation();
  return (
    <div className="provider-select" style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: '0.8rem' }}>
      <span style={{ color: 'var(--text-dim)' }}>{t('provider.providedBy')}</span>
      {(['band', 'venue'] as const).map((opt) => (
        <button
          key={opt}
          type="button"
          onClick={() => onChange(opt)}
          disabled={disabled}
          className={`rc-pill${value === opt ? ' on' : ''}`}
          style={{ padding: '2px 10px', fontSize: '0.75rem', cursor: disabled ? 'default' : 'pointer' }}
        >
          {opt === 'band' ? t('provider.band') : t('provider.venue')}
        </button>
      ))}
    </div>
  );
}
